import { logOut, setToken } from "../api/config";
import { userAtom } from "@/store/user";
import { useSetRecoilState } from "recoil";
import { useNavigate } from "react-router";

const useQuit = () => {
  const removeUser = useSetRecoilState(userAtom);
  const navigate = useNavigate();

  const quit = (redirect?: string) => {
    localStorage.removeItem("user");
    logOut();
    removeUser({});
    navigate(
      `/login?goto=${encodeURIComponent(
        redirect || `${location.pathname}${location.search}`
      )}`
    );
  };
  return { quit };
};

export default useQuit;
